export default __webpack_public_path__ + "static/media/EngineeringDams_02.c76cf74e.png";